import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const certificateTypeManagement = {
    major: {
        queryList: config => createAPI('/skillRecognition/certificateTypeManagement/queryList', 'post', config),
        // initCombo: config => createAPI('/skillRecognition/certificateManagement/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/certificateTypeManagement/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/certificateTypeManagement/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/certificateTypeManagement/releaseRecById', 'post', config),
    },
};

export default certificateTypeManagement;



// WEBPACK FOOTER //
// ./src/api/modules/certificateTypeManagement.js